export default "__VITE_ASSET__DrZUjlII__"